import React, { Component } from 'react';
import { Alert, Glyphicon } from 'react-bootstrap';

import '../styles/Notifications.css';

class Notifications extends Component {
  render() {
    const {
      alerts,
      isInvoking,
      invokingMessage,
      onDismissAlert,
      newUser,
      updatingUser,
      isAuthenticating,
      isFetchingCredentials,
      error,
      errorMessage
    } = this.props;
    return (
      <div>
        { error ?
          <Alert bsStyle="danger" className="authenticating">
            {errorMessage}
          </Alert>
          :
          null
        }
        { isAuthenticating ?
          <Alert bsStyle="warning" className="authenticating">
            Authenticating
          </Alert>
          :
          null
        }
        { isFetchingCredentials ?
          <Alert bsStyle="warning" className="authenticating">
            Getting Credentials
          </Alert>
          :
          null
        }
        { isInvoking ?
          <Alert bsStyle="success" className="fetching">
            <Glyphicon glyph="refresh" className="spinning" />{invokingMessage}
          </Alert>
          :
          null
        }
        { alerts.map((alert) => (
            <Alert bsStyle={alert.style} key={alert.id} onDismiss={() => onDismissAlert(alert.id)}>
              {alert.message}
            </Alert>
          )
        )}
        { newUser ?
          <Alert bsStyle="warning" className="new-user">
            First time user. Your account is being created. Some functionality may not work right away.
          </Alert>
          :
          null
        }
        { updatingUser ?
          <Alert bsStyle="warning" className="updating-user">
            Your user information is being refreshed. The page will update when complete.
          </Alert>
          :
          null
        }
      </div>
    );
  }
}

export default Notifications;